import { Injectable } from '@angular/core';
import moment from 'moment';
import { GlobalSettingsService } from './global-settings.service';

@Injectable({
  providedIn: 'root'
})
export class DataFeedNotificationService {
  private PREFIX = 'live-feed-item-';
  private notifications: Record<string, any> = {};
  private dismissedNotifications: Record<string, any> = {};
  private reports: Record<string, any> = {};
  private mytasks: Record<string, any> = {};
  private mySopTaskIds: any = null;
  private notificationIdsList: string[] = [];
  private count = 0;
  private total = 0;
  private update = 0;

  private IN_PROGRESS = 'In Progress';
  private COMPLETED = 'Completed';
  constructor(private globalSettings: GlobalSettingsService) { }
  private lastAlertSoundTime = new Date();

  resetDismissedNotifications() {
    this.dismissedNotifications = {};
  }

  removeNotification(notificationId: string) {
    delete this.notifications[notificationId];
    const index = this.notificationIdsList.indexOf(notificationId);
    if (index > -1) {
      this.notificationIdsList.splice(index, 1);
    }
    this.count--;
    this.update++;
    this.total--;
  }

  getNotificationsAsList() {
    return this.notificationIdsList.map(id => this.notifications[id]);
  }

  getDismissedNotificationsAsList() {
    return Object.values(this.dismissedNotifications);
  }

  getNotificationsCount() {
    return this.count;
  }
  getNotificationsTotal() {
    return this.total;
  }
  getNotificationsActive() {
    return Object.values(this.notifications).filter(noti => !noti.status || noti.status === 'active').length;
  }
  getNotificationsDismissed() {
    return Object.values(this.notifications).filter(noti => noti.status === 'dismissed').length;
  }
  getNotificationsRead() {
    return Object.values(this.notifications).filter(noti => noti.alertRead).length;
  }

  getNotification(notificationId: string) {
    return this.notifications[notificationId];
  }

  addNotificationObject(obj: any) {
    obj.completed = false;
    obj.formattedCreationTime = moment().format('MMM Do YYYY  h:mm:ss A');
    obj.aaActivityLog = [];
    this.notifications[obj.id] = obj;
    this.notificationIdsList.push(obj.id);

    this.count++;
    this.total++;
    this.update++;

    let sound = true;
    if (!this.globalSettings.getAlertChime()) {
      sound = false;
    }

    const now = new Date();
    if (sound && now.getTime() - this.lastAlertSoundTime.getTime() > 1000) {
      const audio = new Audio('assets/sound/ios_notification1.mp3');
      audio.play().catch((e) => {
      });
      this.lastAlertSoundTime = new Date();
    }
  }

  addDismissedNotificationObject(obj: any) {
    this.dismissedNotifications[obj.id] = obj;
  }

  readNotificationObject(obj: any) {
    obj.completed = false;
    this.notifications[obj.id] = obj;
    this.notificationIdsList.push(obj.id);

    this.count++;
    this.update++;
  }

  getEntityIdFromNotificationId(notificationId: string) {
    return this.notifications[notificationId]?.entityId;
  }

  addUpdate() {
    this.update++;
  }

  // ... Implement other methods as needed, e.g., addToMyTasks, addToMyReports, etc.
}
